// Favicon d'une boutique.
//  - Si le revendeur a importé un logo -> on utilise SON logo.
//  - Sinon -> on GÉNÈRE un favicon à partir de l'initiale du nom de la boutique
//    (jamais le favicon du site principal Numwave).

function initials(name) {
  const s = String(name || "").trim();
  if (!s) return "?";
  // Une initiale par mot (2 max) ; ignore les symboles.
  const words = s.split(/[\s\-_.]+/).filter(Boolean);
  const pick = (w) => { const m = w.match(/[\p{L}\p{N}]/u); return m ? m[0] : ""; };
  const two = words.slice(0, 2).map(pick).join("");
  return (two || s[0]).toUpperCase();
}

// Renvoie un data-URL SVG : carré arrondi (couleur du thème) + initiales blanches.
export function faviconFromName(name, accent = "#0ea884") {
  const ch = initials(name);
  const size = ch.length > 1 ? 28 : 38;
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">` +
    `<rect width="64" height="64" rx="14" fill="${accent}"/>` +
    `<text x="50%" y="50%" dy=".07em" text-anchor="middle" dominant-baseline="central" ` +
    `font-family="Arial,Helvetica,sans-serif" font-size="${size}" font-weight="700" fill="#ffffff">${ch}</text>` +
    `</svg>`;
  return "data:image/svg+xml," + encodeURIComponent(svg);
}

// Favicon effectif d'une boutique : logo importé si présent, sinon généré du nom.
export function shopFavicon(shop, accent) {
  const logo = (shop && shop.logo_url ? String(shop.logo_url) : "").trim();
  if (logo) return logo;
  return faviconFromName(shop && shop.shop_name, accent);
}
